import {InforDepartmentCode} from '@domain/shifthandover'
import {type ShiftEventCategory} from '@hconnect/common/types'

export function categoryToInforDepartmentCodeMapper(
  category: ShiftEventCategory | undefined
): InforDepartmentCode | undefined {
  if (Object.values(InforDepartmentCode).includes(category as unknown as InforDepartmentCode)) {
    return category as unknown as InforDepartmentCode
  }
  return undefined
}
